// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","btn-tab":"styles_btn-tab__qgpCH","btnTab":"styles_btn-tab__qgpCH","active":"styles_active__1cLnn","icon":"styles_icon__1LuHZ"};